import script from "./ProjectRecycleOverview.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectRecycleOverview.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__